var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 5C16.5 4.44772 16.9477 4 17.5 4H18.5C19.6046 4 20.5 4.89543 20.5 6V14C20.5 15.1046 19.6046 16 18.5 16H4.5C3.39543 16 2.5 15.1046 2.5 14V11C2.5 10.4477 2.94772 10 3.5 10C4.05228 10 4.5 10.4477 4.5 11V14H18.5V6H17.5C16.9477 6 16.5 5.55228 16.5 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2C0.5 0.895431 1.39543 0 2.5 0H16.5C17.6046 0 18.5 0.89543 18.5 2V10C18.5 11.1046 17.6046 12 16.5 12H2.5C1.39543 12 0.5 11.1046 0.5 10V2ZM16.5 2L2.5 2V10H16.5V2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 5C8.94772 5 8.5 5.44772 8.5 6C8.5 6.55228 8.94772 7 9.5 7C10.0523 7 10.5 6.55228 10.5 6C10.5 5.44772 10.0523 5 9.5 5ZM6.5 6C6.5 4.34315 7.84315 3 9.5 3C11.1569 3 12.5 4.34315 12.5 6C12.5 7.65685 11.1569 9 9.5 9C7.84315 9 6.5 7.65685 6.5 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.4c52812d4455eb7e3958310ba64f4bfe.svg";
export { ForwardRef as ReactComponent };